export const DEFAULT_CRM_TOKEN = 't88g6im8nqh';
export const brandLogo = `${window.assetsLocation}/images/logo.jpg`;
export const brandShowcaseUrl = `${window.assetsLocation}/images/logo.png`;
export const bannerUrl = `${window.assetsLocation}/images/banner.jpg`;
export const viewReportIconUrl = `${window.assetsLocation}/images/carousel.png`;
export const submitRequestIconUrl = `${window.assetsLocation}/images/request.svg`;
export const loginRequestsIconUrl = `${window.assetsLocation}/images/inbox.svg`;
export const viewAllRequestsIconUrl = `${window.assetsLocation}/images/map.svg`;
export const homeArticleIds = ['11'];
export const faqArticleIds = ['4', '5', '6', '7', '8', '9', '10'];
